import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3110da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roleManager" }
const _hoisted_2 = { class: "search_div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "角色名：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "后台菜单权限", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "角色管理" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_select, {
          modelValue: _ctx.roleName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleName) = $event)),
          clearable: "",
          placeholder: "请选择角色名称"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.getRolesLists
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRole()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        border: "",
        style: {"width":"100%"},
        "header-row-class-name": "tb_bg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "角色名字"
          }),
          _createVNode(_component_el_table_column, {
            prop: "count",
            label: "已关联员工"
          }),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注"
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.showRole(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.delRole(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.roleDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.roleDialog) = $event)),
      title: _ctx.form.id?'编辑角色':'新增角色',
      width: "400px",
      onClose: _ctx.closeInfo
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "120px",
          "label-position": "left",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "角色名",
              prop: "role_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.role_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.role_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.remark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_8,
        (_ctx.roleDialog)
          ? (_openBlock(), _createBlock(_component_el_tree, {
              key: 0,
              data: _ctx.menuTree,
              props: _ctx.defaultProps,
              "node-key": "id",
              "show-checkbox": "",
              onCheckChange: _ctx.handleCheckChange,
              "default-checked-keys": _ctx.defaultCheck,
              "default-expand-all": ""
            }, null, 8, ["data", "props", "onCheckChange", "default-checked-keys"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.roleClick
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.closeInfo }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onClose"])
  ], 64))
}